import { useEffect, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader, vibrantTheme } from "../components/common";
import { parseGuide, ParsedSections } from "../components/ArticleSections";
import { GUIDES } from "../content/guides";
import { SITE } from "../lib/site";

export default function SectionGuide() {
  const { mode } = useParams();
  const guide = GUIDES[mode];
  const sections = useMemo(() => (guide ? parseGuide(guide.raw) : []), [guide]);
  useEffect(() => { window.scrollTo(0, 0); }, [mode]);

  if (!guide) {
    return <div className="max-w-3xl mx-auto px-5 py-24 text-center text-muted-foreground" data-testid="guide-not-found">Guide not found.</div>;
  }

  return (
    <div className="min-h-screen bg-background" data-testid={`guide-page-${mode}`}>
      <PageHeader
        eyebrow={`${SITE.name} \u00b7 Travel Guide`}
        title={`${guide.emoji} ${guide.title}`}
        subtitle={guide.subtitle}
        entityCode={`guide-${mode}`}
      />
      <div className="max-w-4xl mx-auto px-5 lg:px-8 py-12 space-y-14">
        <Link to={guide.linkTo} data-testid="guide-back-link"
          className="inline-flex items-center gap-1 text-sm font-700 text-primary hover:underline">
          <ArrowLeft className="w-4 h-4" /> Open the {guide.linkLabel} section
        </Link>

        <ParsedSections sections={sections} prefix={`guide-${mode}`} />

        <section className="text-white p-8 sm:p-12 text-center" style={{ backgroundColor: vibrantTheme(`guide-${mode}-closing`).bg }} data-testid="guide-closing">
          <div className="font-heading font-900 text-2xl sm:text-3xl">TravelerPulse.pro{"\u2122"}</div>
          <div className="text-sm text-white/85 mt-1">The Global Travel &amp; Transportation Community</div>
          <div className="font-mono text-sm tracking-[0.18em] text-white/90 mt-3">{guide.motto}</div>
        </section>
      </div>
    </div>
  );
}
